import { render, staticRenderFns } from "./ProjectsDropDownList.vue?vue&type=template&id=ec237870"
import script from "./ProjectsDropDownList.vue?vue&type=script&lang=js"
export * from "./ProjectsDropDownList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports